import { fmt, fmtDuration, fmtRelative } from '../utils/format';

const STATUS_STYLE = {
  completed: 'bg-greenColor/15 text-greenColor',
  completed_with_errors: 'bg-orangeColor/15 text-orangeColor',
  running: 'bg-darkBlueColor/15 text-darkBlueColor',
  pending: 'bg-yellowColor/15 text-darkGrayColor',
  cancelled: 'bg-lightGrayColor text-darkGrayColor',
  cancelling: 'bg-lightGrayColor text-darkGrayColor',
  failed: 'bg-redColor/15 text-redColor',
};

const StatusPill = ({ status }) => (
  <span
    className={
      'inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium uppercase tracking-wider ' +
      (STATUS_STYLE[status] || 'bg-lightGrayColor text-darkGrayColor')
    }
  >
    {status}
  </span>
);

const durationSec = batch => {
  if (!batch.started_at) return null;
  const end = batch.finished_at
    ? new Date(batch.finished_at).getTime()
    : Date.now();
  return Math.round((end - new Date(batch.started_at).getTime()) / 1000);
};

// Compact 5-row table of most recent batches. Read-only.
export const RecentBatchesTable = ({ batches = [] }) => {
  const rows = (batches || []).slice(0, 5);

  if (!rows.length) {
    return (
      <div className="text-xs text-darkGrayColor py-4 text-center rounded border border-gray-200 bg-white">
        No recent batches.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <table className="min-w-full text-xs">
        <thead className="bg-lightestGrayColor text-darkGrayColor">
          <tr>
            <th className="text-left px-3 py-2 font-medium">ID</th>
            <th className="text-left px-3 py-2 font-medium">Status</th>
            <th className="text-right px-3 py-2 font-medium">Total</th>
            <th className="text-right px-3 py-2 font-medium">Duration</th>
            <th className="text-right px-3 py-2 font-medium">Started</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((b, i) => (
            <tr
              key={b.id}
              className={
                'text-blackColor hover:bg-lightestGrayColor transition-colors ' +
                (i > 0 ? 'border-t border-gray-100' : '')
              }
            >
              <td className="px-3 py-2 font-medium">#{b.id}</td>
              <td className="px-3 py-2">
                <StatusPill status={b.status} />
              </td>
              <td className="px-3 py-2 text-right">{fmt(b.total)}</td>
              <td className="px-3 py-2 text-right">
                {fmtDuration(durationSec(b))}
              </td>
              <td className="px-3 py-2 text-right text-darkGrayColor">
                {fmtRelative(b.started_at)} ago
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
